import constants from 'constants/index'

const statusTranslation = (status, isFaq = false) => {
  if (isFaq) return constants.technicalFaqs.STATUSES_LABELS[status]

  return constants.technicalFaqs.STATUSES_LABELS_IS_FAQ[status]
}

export default statusTranslation
